interface CalendarUnsavedModalProps {
  open: boolean;
  onKeepEditing: () => void;
  onDiscard: () => void;
}

export const CalendarUnsavedModal = ({
  open,
  onKeepEditing,
  onDiscard,
}: CalendarUnsavedModalProps) => {
  if (!open) return null;

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 2000,
      }}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: "1.5rem",
          padding: "2rem",
          maxWidth: 400,
          width: "90%",
          textAlign: "center",
          boxShadow: "0 20px 40px rgba(0,0,0,0.2)",
        }}
      >
        <h3
          style={{
            fontSize: "1.25rem",
            fontWeight: 700,
            color: "#374151",
            marginBottom: "1rem",
          }}
        >
          Cambios sin guardar
        </h3>
        <p
          style={{
            fontSize: "1rem",
            color: "#6b7280",
            marginBottom: "2rem",
            lineHeight: 1.5,
          }}
        >
          Tenés cambios sin guardar en tu configuración de horarios. Si salís ahora, se perderán.
        </p>
        <div style={{ display: "flex", flexDirection: "column", gap: "0.75rem" }}>
          <button
            type="button"
            style={{
              background: "#6D57BC",
              color: "#fff",
              border: "none",
              borderRadius: 9999,
              padding: "0.75rem 1.25rem",
              fontSize: "0.95rem",
              fontWeight: 700,
              cursor: "pointer",
            }}
            onClick={onKeepEditing}
          >
            Seguir editando
          </button>
          <button
            type="button"
            style={{
              background: "#fff",
              color: "#ef4444",
              border: "2px solid #ef4444",
              borderRadius: 9999,
              padding: "0.75rem 1.25rem",
              fontSize: "0.95rem",
              fontWeight: 700,
              cursor: "pointer",
            }}
            onClick={onDiscard}
          >
            Salir sin guardar
          </button>
        </div>
      </div>
    </div>
  );
};
